export const enrolViewData = {
  'gb_wallpaper': 'https://idaily-img.s3.eu-west-2.amazonaws.com/m-6u-25-06-21-19-17-00-exam-revision.jpg',
  'gb_status': 'Online learning academy for GCSE & A-Level',
  'za_wallpaper': 'https://idaily-img.s3.eu-west-2.amazonaws.com/m-6u-25-06-21-20-06-22-exam-revision.jpg',
  'za_status': 'Online learning academy for Matric',
  'zw_wallpaper': 'https://idaily-img.s3.eu-west-2.amazonaws.com/m-6u-25-06-21-20-06-22-exam-revision.jpg',
  'zw_status': 'Online learning academy for ZIMSEC',
  'ke_wallpaper': 'https://idaily-img.s3.eu-west-2.amazonaws.com/m-6u-25-06-21-20-06-22-exam-revision.jpg',
  'ke_status': 'Online learning academy for KCSE',
};